import { useViewJobDislike } from "./useViewJobDislike.web";
import { DislikeButton } from "../../../../../../jobcard/components/JobCard/ActionButtons/DislikeButton";

import { useEffect } from "react";

export type ViewJobDislikeButtonProps = {
  jobKey: string;
  jobTitle?: string;
  trackingKey?: string;
  initialIsSaved: boolean;
  onDislikeStateChange?: (isDisliked: boolean) => void;
};

export function ViewJobDislikeButton({
  jobKey,
  jobTitle,
  trackingKey,
  initialIsSaved,
  onDislikeStateChange,
}: ViewJobDislikeButtonProps) {
  const { isDisliked, isPending, onPressDislike } = useViewJobDislike({
    jobKey,
    trackingKey,
    initialIsSaved,
  });

  useEffect(() => {
    onDislikeStateChange?.(isDisliked);
  }, [isDisliked, onDislikeStateChange]);

  return (
    <DislikeButton
      appearanceMode="utility"
      disabled={isPending}
      isDisliked={isDisliked}
      jobTitle={jobTitle}
      onPressDislike={onPressDislike}
      testID="vj-dislikeJobButton"
    />
  );
}
